<template>
  <v-app dark>
    <v-navigation-drawer
      v-model="drawer"
      :mini-variant="miniVariant"
      :clipped="clipped"
      fixed
      app
    >
      <div style="width: 100%; text-align: center; padding-top: 10px">
        <img src="../../assets/DNA-Logo.png" width="170px" />
      </div>
      <v-list dense>
        <template v-for="item in items">
          <v-list-group
            v-if="item.children"
            :key="item.text"
            v-model="item.model"
            :prepend-icon="item.model ? item.icon : item['icon-alt']"
            append-icon=""
          >
            <template v-slot:activator>
              <v-list-item-content>
                <v-list-item-title>
                  {{ item.text }}
                </v-list-item-title>
              </v-list-item-content>
            </template>
            <v-list-item
              v-for="(child, i) in item.children"
              :key="i"
              link
              :to="child.to"
            >
              <v-list-item-action v-if="child.icon">
                <v-icon>{{ child.icon }}</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>
                  {{ child.text }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-group>
          <v-list-item v-else :key="item.text" link :to="item.to">
            <v-list-item-action>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>
                {{ item.text }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>
      </v-list>
    </v-navigation-drawer>
    <v-app-bar :clipped-left="clipped" fixed app>
      <v-app-bar-nav-icon @click.stop="drawer = !drawer" />
      <v-toolbar-title v-text="$store.state.pageTitle" />
       <v-spacer></v-spacer>
       <v-switch
            v-model="switch1"
            @click="changetheme"
          ></v-switch>
    </v-app-bar>
    <v-main>
      <div class="pa-2" style="background-color:#e9e9e9; min-height:100%;">
        <router-view></router-view>
      </div>
    </v-main>
    <v-footer :absolute="!fixed" app>
      <span>&copy; {{ new Date().getFullYear() }}</span>
    </v-footer>
  </v-app>
</template>

<script>
export default {
  data() {
    return {
      switch1: false,
      clipped: false,
      drawer: true,
      fixed: false,
      items: [
        { icon: "mdi-apps", text: "Dashboard", to: "/admin" },
        
        {
          icon: "mdi-chevron-up",
          "icon-alt": "mdi-chevron-down",
          text: "Masters",
          model: false,
          children: [
            { icon: "mdi-plus", text: "Event Setup", to: "/admin/Events" },

            
            { icon: "mdi-plus", text: "Status", to: "/admin/status" },
            { icon: "mdi-plus", text: "Companytype jobtype map", to: "/admin/Companyjobtypemap" },
            { icon: "mdi-plus", text: "Cardsetup", to: "/admin/cardsetup" },
            { icon: "mdi-plus", text: "IDproofsetup", to: "/admin/idproofsetup" },
            { icon: "mdi-plus", text: "Job Zone Mapping", to: "/admin/jobzone" },
            { icon: "mdi-plus", text: "Job/Admin Mapping", to: "/admin/jobAdmin" },
            
            { icon: "mdi-account", text: "Uesrs", to: "/admin/users" },
          
             
          ],
        },


{
          icon: "mdi-chevron-up",
          "icon-alt": "mdi-chevron-down",
          text: "Media",
          model: false,
          children: [
            { icon: "mdi-plus", text: "Role", to: "/admin/media" },
             { icon: "mdi-plus", text: "Category", to: "/admin/mediacategory" },
             { icon: "mdi-plus", text: "Job", to: "/admin/mediajob" },

            
            //  { icon: "mdi-plus", text: "Sub Category", to: "/admin/media" },
             
          ],
        },


        {
          icon: "mdi-chevron-up",
          "icon-alt": "mdi-chevron-down",
          text: "Setting",
          model: false,
          children: [
            { icon: "mdi-plus", text: "Event Prefrence Setting", to: "/admin/setting" },
          ],
        },
        { icon: "mdi-logout", text: "Logout", to:"/" },
      ],
      miniVariant: false,
      right: true,
      rightDrawer: false,
      title: "Vuetify.js",
    };
  },
  methods:{
     changetheme: function () {
      if(this.switch1==true)
      {
this.$vuetify.theme.dark = true;
      }
      if(this.switch1==false)
      {
this.$vuetify.theme.dark = false;
      }
    },
  },
 
};
</script>
